/**
 * One multi-selection, shared by every component that needs it.
 *
 * The overlay draws the selection and the context menu offers Group/Ungroup on it, and
 * those two live in different branches of the tree (SlideContents and ContextMenu are
 * siblings inside MainLayout). A module-level store keeps them in agreement without
 * threading a provider through MainLayout.
 *
 * This also matches how selection already works here: use-resizer keeps single
 * selection in the DOM and useSelectedObject observes it globally, with no provider.
 */

let state = { selectedIds: [], activeGroupId: null };
const listeners = new Set();

export const getGroupSelection = () => state;

export const subscribeGroupSelection = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Replace the selection. `updater` receives the current state and returns the next. */
export const setGroupSelection = (updater) => {
  const next = typeof updater === 'function' ? updater(state) : updater;
  if (next === state) return;
  state = next;
  listeners.forEach((listener) => listener());
};

/** Test seam: drop all state and listeners. */
export const resetGroupSelection = () => {
  state = { selectedIds: [], activeGroupId: null };
  listeners.clear();
};
